module.exports = __webpack_public_path__ + "img/user.c6e79fdf.png";